<template>
  <div>
    <b-navbar v-if="isLoggedIn" :fixed-top="true" class="shdw">
      <template slot="brand">
        <b-navbar-item @click="$nav.home">
          <img :src="navbarLogo" alt="TripCircuit wired for Gant Travel Management" />
        </b-navbar-item>
      </template>
      <template slot="end">
        <b-navbar-item v-if="$globals.profile.firstName" class="is-hidden-desktop">
          <b class="is-block">{{ $globals.profile.firstName }} {{ $globals.profile.lastName }}</b>
          <b class="secondary-text">{{ $globals.profile.email }}</b>
        </b-navbar-item>
        <b-navbar-item v-if="this.$route.path !== '/home'" class="navbar-item-label" @click="$nav.home">
          Home
        </b-navbar-item>
        <b-navbar-item v-if="bookTrip.currentlyBooking" class="bookingDropdownTrigger">
          <SmallItinerarySidebar :sol="solutionAll"
            :key="solutionAll.flight.key + solutionAll.hotel.key + solutionAll.car.key" />
        </b-navbar-item>
        <b-navbar-item v-else class="navbar-item-label" @click="$nav.searchGo">
          Book Trip
        </b-navbar-item>
        <b-navbar-item v-if="$globals.profile.firstName" class="navbar-item-label" @click="$nav.tripsGo">
          My Trips
        </b-navbar-item>
        <!-- Travel Admin-->
        <b-dropdown v-if="$globals.profile.isTravelChampion" append-to-body aria-role="menu" position="is-bottom-left" class="is-hidden-touch">
          <a slot="trigger" role="button" class="navbar-item">
            <b class="is-block">Travel Admin</b>
          </a>
          <b-dropdown-item aria-role="menuitem" @click="$nav.accountSettingsGo">
            <b class="is-block gant-text">Account Settings</b>
          </b-dropdown-item>
          <b-dropdown-item aria-role="menuitem" @click="$nav.manageUsersGo">
            <b class="is-block gant-text">Manage Users</b>
          </b-dropdown-item>
          <b-dropdown-item aria-role="menuitem" @click="$nav.manageTravelPolicies">
            <b class="is-block gant-text">Manage Travel Policies</b>
          </b-dropdown-item>
        </b-dropdown>
        <!-- End Travel Admin -->
        <b-navbar-item class="navbar-item-label is-hidden-desktop" @click="$nav.travelersGo">
          My Travelers
        </b-navbar-item>
        <!-- <b-navbar-item class="navbar-item-label is-hidden-desktop" @click="$nav.manageTravelPolicies">
          Travel Policy Manager
        </b-navbar-item> -->
        
        <UserNeedHelpDropdown />
        <b-dropdown append-to-body aria-role="menu" position="is-bottom-left" class="is-hidden-touch">
          <a slot="trigger" role="button" class="navbar-item">
            <b-icon icon="account-circle" />
          </a>
          <b-dropdown-item custom aria-role="menuitem">
            <b class="is-block gant-text">{{ $globals.profile.firstName }} {{ $globals.profile.lastName }}</b>
            <b class="secondary-text">{{ $globals.profile.email }}</b>
            <hr class="dropdown-divider" aria-role="menuitem" />
          </b-dropdown-item>
          <!-- <b-dropdown-item aria-role="menuitem" @click="$nav.searchGo">
            <b class="is-block gant-text">Book Trip</b>
          </b-dropdown-item>
          <b-dropdown-item v-if="$globals.profile.firstName" aria-role="menuitem" @click="$nav.tripsGo">
            <b class="is-block gant-text">My Trips</b>
          </b-dropdown-item> -->
          <b-dropdown-item aria-role="menuitem" @click="$nav.travelersGo">
            <b class="is-block gant-text">My Travelers</b>
          </b-dropdown-item>
          <hr class="dropdown-divider" aria-role="menuitem" />
          <b-dropdown-item value="$app.logout" aria-role="menuitem" @click="$nav.out">
            <b-icon icon="logout" />
            <span class="krungthep">Logout</span>
          </b-dropdown-item>
        </b-dropdown>
        <b-navbar-item href="https://www.gantgateway.com/profile" target="_blank" class="customImageLink">
          <img src="/images/logo-1024x454.png" alt="visit Gant Gateway" />
          <img src="/images/Go_Icon.png" class="ml-2" alt="Visit Gant Gateway" />
        </b-navbar-item>
        <b-navbar-item v-if="$globals.profile.firstName" class="is-hidden-desktop krungthep" @click="$nav.out">
          Logout
        </b-navbar-item>
      </template>
    </b-navbar>
    <div v-if="isLoggedIn && pathMixin_isBookingPageWithoutTravelerBar">
      <div v-if="$globals.travellers.set && !$route.path.match(/(^\/meetings)/)"
        class="notification has-text-centered is-size-7"
        style="margin: 0; position: fixed; top: 60px; width: 100%; z-index: 10; padding:  5px 1rem 5px 1rem; background: #f8eacf;">
        <div class="columns">
          <div class="column">
            <span class="bookingVerbDesktop">You are now booking </span>
            <span class="bookingVerbMobile">Booking </span>
            <strong>{{ $globals.travellers.tripType }}</strong> travel for
            <strong>
              {{
                $globals.travellers.bookFor === "others"
                ? `${currentTravellerProfile.firstName} ${currentTravellerProfile.lastName}`
                : "yourself"
              }}
            </strong>
            <a class="ml-4 is-small is-size-7" @click="openCardModal">Change</a>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import bookingMixin from "../../mixins/bookingMixin";
import TravellerModal from "../Traveller/TravellerModal.vue";
import UserNeedHelpDropdown from "../User/UserNeedHelpDropdown";
import SmallItinerarySidebar from "../Itinerary/SmallItinerarySidebar";

export default {
  name: "MainNavBar",
  mixins: [bookingMixin],
  components: {
    UserNeedHelpDropdown,
    SmallItinerarySidebar,
  },
  data() {
    return {
      page: 1,
      data: [],
      totalPages: 1,
      selected: null,
      isFetching: false,
    };
  },
  computed: {
    isLoggedIn() {
      return Object.keys(this.$globals.profile).length > 0;
    },
    currentTravellerProfile() {
      return this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"];
    },
    navbarLogo() {
      const defaultUrl = "/images/TripCircuit-Logo-white.png";
      const configUrl = this.$globals.profile?.tripCircuitConfiguration?.logoUrl || "";

      return configUrl || defaultUrl;
    },
  },
  methods: {
    openCardModal() {
      this.$buefy.modal.open({
        width: 700,
        parent: this,
        trapFocus: false,
        hasModalCard: true,
        component: TravellerModal,
        props: { profile: this.$globals.profile },
      });
    },
  },
};
</script>
